import React from 'react'
import { Link as SLink } from './styled';

export const Link = ({...props}) => {

  return (
    <SLink {...props} />
  )
}